import React from "react";

const Skills=()=>{
    return  <>
<h1 id ="Skills">Skills</h1>
        
          <h2>Front-end Proficiencies</h2>
          
          <li>HTML</li>
          <li>CSS</li>
          <li>JavaScript</li>
          <li>jQuery</li>
          <li>responsive design</li>
          <li>React</li>
          <li>Bootstrap</li>

          <h3>Back-end Proficiencies</h3>
        
          <li>APIs</li>
          <li>Node</li>
          <li>Express</li>
          <li>MySQL, Sequelize</li>
          <li>MongoDB, Mongoose</li>
          <li>REST</li>
          <li>GraphQL</li>



</>
}




export default Skills;